import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

let resolve = {
  roles: /*@ngInject*/ Role => Role.query().$promise,
}

/**
 * Add User route
 *
 * @namespace routes.AdminUsersFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'admin.users.add',
  params: {
    place: null,
    submitAndContinue: null,
  },
  resolve,
}

/**
 * Edit User route
 *
 * @namespace routes.AdminUsersFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'admin.users.view.edit',
  resolve,
}

export const routes = [addRoute, editRoute]

/**
 * User add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminUserForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminUserFormController',
  bindings: {
    loggedUser: '<',
    resource: '<',
    toast: '<',
    roles: '<',
  },
}

/**
 * Controller of component {@link tmrAdminUserForm}.
 *
 * @type {ngController}
 */
export class tmrAdminUserFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    $filter,
    $locale,
    TmrApiAuth,
    Place,
    tmrUserDateFormats,
    tmrLanguages
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      $filter,
      $locale,
      TmrApiAuth,
      Place,
      tmrUserDateFormats,
      tmrLanguages,
    })
  }

  $onInit() {
    super.$onInit()

    // Get languages list.
    this.languageList = this.tmrLanguages.languages

    // Default roles. Keys are ids, values are true (i.e.: checked).
    this.checkedRoles = {}
    if (this.roles) {
      this.roles.forEach(
        ({ id }) =>
          (this.checkedRoles[id] = !!this.resource.roles.find(
            role => role.id == id
          ))
      )
    }

    if (this.$stateParams.place) {
      this.resource.place = this.$stateParams.place
      this.placeText = this.$stateParams.place.description
    }

    // Preferred date format select.
    this.dateFormats = {}
    this.tmrUserDateFormats.forEach(format => {
      if (this.$locale.DATETIME_FORMATS[format] !== undefined) {
        this.dateFormats[format] = `${
          this.$locale.DATETIME_FORMATS[format]
        } - ${this.$filter('date')(new Date(), format)}`
      }
    })

    // Workaround for bug where data was double-encoded and md-select not getting default value.
    while (typeof this.resource.data === 'string')
      this.resource.data = JSON.parse(this.resource.data)
    this.resource.data = this.resource.data ?? {}
    this.resource.data.language = this.resource.data.language ?? ''
    this.resource.data.dateFormats = this.resource.data.dateFormats ?? ''
  }

  /** Query to get places for md-autocomplete */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  /** Toggles clicked user role */
  toggleRole() {
    this.resource.roles = this.roles.filter(role => this.checkedRoles[role.id])
  }

  /** @override */
  save() {
    // Backend errors when complete role objects are sent; so send only ids.
    this.resource.roles = this.resource.roles.map(role => ({ id: role.id }))
    return super.save()
  }

  /** @override */
  onSaved() {
    return this.onUserSaved(this.redirect)
  }

  /** @override */
  onSavedContinue() {
    return this.onUserSaved(this.$state.current, {
      place: this.resource.place,
      submitAndContinue: true,
    })
  }

  onUserSaved(destination, params) {
    let toast = () => this.TmrToast.success(this.toast)
    if (this.resource.id == this.loggedUser.id) {
      return this.TmrApiAuth.updateLoggedUser(null, destination, params).then(
        toast
      )
    }
    return this.$state
      .go(destination, params, { reload: true, inherit: false })
      .then(toast)
  }
}
